import http from 'axios';
import Vue from 'vue';
import * as tools from './tools'
import { setToken, removeToken } from '@/utils/auth'
import storage from '@/utils/storage'
var mesg = '';

http.interceptors.response.use(
  response => {
    const res = response.data
    // if (res.code == -10) {
    //   Vue.prototype.$notify({
    //     title: '提示信息',
    //     message: res.message,
    //     type: 'warning',
    //     position: 'top-right',
    //     duration: 3000
    //   })
    //   //Cookies.remove('user')
    //   removeToken()
    //   window.location.reload()
    // }else if(res.code == 200 && res.data && res.data.length==0){
    // Vue.prototype.$notify({
    //   title: '提示信息',
    //   message: '暂无数据',
    //   type: 'warning',
    //   position: 'top-right',
    //   duration: 5000
    // })

    // } else if (res.code == 505) {
    //   Vue.prototype.$notify({
    //     title: '提示信息',
    //     message: res.message,
    //     type: 'warning',
    //     position: 'top-right',
    //     duration: 3000
    //   })
    if (res.code == 200) {
      if (res.data && res.data.list && res.data.list.length == 0) {
        Vue.prototype.$notify({
          title: '提示信息',
          message: '暂无数据',
          type: 'warning',
          position: 'top-right',
          duration: 5000
        })
      }
    } else if (res.code != 200) {
      res.message=res.message||"";//防止message返回null
      if (mesg != res.message) {
        Vue.prototype.$notify({
          title: '提示信息',
          message: res.message,
          type: 'warning',
          position: 'top-right',
          duration: 3000
        })
      }
      mesg = res.message;
      setTimeout(() => { mesg = '' }, 3300)
      if (res.code == 505) {
        setTimeout(() => {
          http.post('/bi-api/logout').then(e => {
            // if (e.code == 200) {
            storage.remove('areaList');
            storage.remove('permissions');
            tools.clearCookie();
            if ((vm.$route.path).indexOf("roadOperation") !== -1||(vm.$route.path).indexOf("roadLogin") !== -1) {
              vm.$router.push({
                path: '/roadLogin'
              })
            } else {
              vm.$router.push({
                path: '/login'
              })
            }
            // }
          })
        }, 500);
        return ;
      }
      if (res.code == -10) {
        storage.remove('permissions');
        tools.clearCookie();
        removeToken()
        if ((vm.$route.path).indexOf("roadOperation") !== -1) {
          vm.$router.push({
            path: '/roadLogin'
          })
        } else {
          vm.$router.push({
            path: '/login'
          })
        }
      }
      // if (res.code == -1) {
      //   tools.clearCookie();
      //   setTimeout(function(){
      //     window.history.back()
      //   },1500)
      // }
    }
    if (res.error) {
      tools.notify({
        type: 'error',
        message: res.error.message
      })
      if (res.code === '-10') {
        // 接口自定义错误代码
        // 移除登陆token 显示接口错误消息
      }
      return Promise.reject(res)
    }
    return Promise.resolve(res)
  },
  error => {
    Vue.prototype.$notify({
      type: 'error',
      message: error.message,
      duration: 3000
    })
    return Promise.reject(error)
  }
)
export default http